import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { FetchState } from "../../../domain/models/fetch-state";
import { AddHqDistance } from "../../../domain/useages/hq-distance-report/add-hq-distance";
import { RemoteAddHqDistance } from "../../../data/usecases/hq-distance-report/remote-add-hq-distance";
import { HqDistanceStore } from "../../main/HqDistanceStore";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface AddHqDistanceInterface {
  addHqDistance: Function;
  addHqDistanceState: FetchState;
}

const initialState = {
  addHqDistanceState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddHqDistanceSlice: StateCreator<AddHqDistanceInterface> = (
  set,
  get
) => ({
  ...initialState,
  addHqDistance: async (payload: AddHqDistance.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    set({ addHqDistanceState: FetchState.LOADING });

    const remoteAddHqDistance: AddHqDistance = new RemoteAddHqDistance(
      `${BASE_URL}${Endpoints.ADD_HQ_DISTANCE}`,
      axiosHttpClient
    );
    let result = await remoteAddHqDistance.add(payload);
    if (result.success === true) {
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
      set({ addHqDistanceState: FetchState.SUCCESS });
      HqDistanceStore.getState().fetchHqDistance(
        HqDistanceStore.getState().hqDistanceFilter
      );
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: result.errors.message ?? result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
      set({ addHqDistanceState: FetchState.SUCCESS });
    }
  },
});
